import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { ViewModel } from '.';

const ReferenceCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps}>
      {data.OrderNumber}<br />
      {data.ReferenceNumber1}
    </td>
  );
}
export default React.memo(ReferenceCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);